// The screen behind an invite / reset link (/?invite=<token>), made in the Dashboard.
// Runs before the login gate: the person following the link has no login yet. A new login
// picks a username + password; a reset sets a new password for the named login. Either way
// the server signs them in, and the page reloads clean (the token never stays in the URL).
import { api, type InviteInfo } from "../api";

export function inviteToken(): string | null {
  return new URLSearchParams(location.search).get("invite");
}

export async function showInviteAccept(token: string): Promise<void> {
  const overlay = document.createElement("div");
  overlay.className = "login-overlay";
  overlay.innerHTML = `<form class="login-card"><div class="login-title">GEAAR</div><div class="login-err">Checking your link…</div></form>`;
  document.body.append(overlay);
  const form = overlay.querySelector("form")!;

  let info: InviteInfo;
  try {
    info = await api.inviteInfo(token);
  } catch (e) {
    form.innerHTML = `
      <div class="login-title">GEAAR</div>
      <div class="invite-msg"></div>
      <a class="login-btn invite-signin" href="/">Go to sign in</a>`;
    form.querySelector(".invite-msg")!.textContent = (e as Error).message;
    return;
  }

  const reset = info.kind === "reset";
  const hello = info.display_name ? `Welcome, ${info.display_name.split(" ")[0]}` : "Welcome";
  form.innerHTML = `
    <div class="login-title">${reset ? "Set a new password" : "GEAAR"}</div>
    <div class="invite-msg"></div>
    ${reset
      ? `<input class="login-input" type="text" autocomplete="username" readonly />`
      : `<input class="login-input" name="u" type="text" placeholder="Choose a username" autocomplete="username" autofocus />`}
    <input class="login-input" name="p" type="password" placeholder="Password (${info.min_password}+ characters)" autocomplete="new-password" ${reset ? "autofocus" : ""} />
    <input class="login-input" name="p2" type="password" placeholder="Password again" autocomplete="new-password" />
    <button class="login-btn" type="submit">${reset ? "Save password and sign in" : "Create login and sign in"}</button>
    <div class="login-err"></div>`;
  form.querySelector(".invite-msg")!.textContent = reset
    ? `Choose a new password for ${info.username}.`
    : `${hello}. You've been invited to ${info.client ?? "GEAAR"}'s project review on GEAAR. Choose a username and password - you'll use them to sign in from now on.`;
  if (reset) (form.querySelector('input[readonly]') as HTMLInputElement).value = info.username ?? "";

  const err = form.querySelector<HTMLDivElement>(".login-err")!;
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const val = (n: string) => (form.elements.namedItem(n) as HTMLInputElement | null)?.value ?? "";
    err.textContent = "";
    if (val("p").length < info.min_password) {
      err.textContent = `Use at least ${info.min_password} characters.`;
      return;
    }
    if (val("p") !== val("p2")) {
      err.textContent = "The two passwords don't match.";
      return;
    }
    const btn = form.querySelector<HTMLButtonElement>("button")!;
    btn.disabled = true;
    try {
      await api.acceptInvite(token, { username: reset ? undefined : val("u").trim(), password: val("p") });
      location.replace("/"); // signed in: start the app fresh, without the token in the URL
    } catch (ex) {
      err.textContent = (ex as Error).message;
      btn.disabled = false;
    }
  });
}
